<template>
  <div
    class="fab-btn"
    @click="() => $emit('click')"
  >
    <div class="fab-btn-text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'FabBtn',
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.fab-btn {
  width : 96px;
  height : 96px;
  background : #FFFFFF;
  box-shadow : 0px 0px 8px 0px rgba(0, 0, 0, .15);
  position : fixed;
  right : 32px;
  bottom : 48px;
  border-radius : 80px;
  display : flex;
  align-items : center;
  justify-content : center;
  flex-shrink: 0;
  overflow: hidden;

  .fab-btn-text {
    font-size : 24px;
    color : #383838;
    font-weight : 400;
    word-break : break-all;
    width: 65%;
    display : flex;
    align-items : center;
    justify-content : center;
    line-height : 35px;
    text-align: center;
  }
}

</style>
